export default "* Hvilke regler er der i legen?\n";